export default "__VITE_ASSET__M$YNiObA__"